/*eslint-disable*/
export default {
  init() {
    jQuery(".stage-name-btn").on("click", function (e) {
      e.preventDefault();
      jQuery(".stage-name-btn").removeClass("active");
      jQuery(".main-stage").removeClass("active");
      jQuery(".speaker-page-stage-wrapper").removeClass("active");
      var _this = jQuery(this);
      _this.addClass("active");

      const className = _this.attr("data-stage");
      jQuery("." + className).addClass("active");
    });

    var hamburger = document.querySelector(".hamburger");
    var body = document.querySelector("body");

    hamburger.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      body.classList.toggle("menu-open");

      var headerWrapper = document.querySelector(".header");
      headerWrapper.classList.toggle("menu-open");
    });
    jQuery(document).ready(function () {
      jQuery(document).on(
        "gform_confirmation_loaded",
        function (event, formId) {
          if (formId == 4) {
            fbq("track", "CompleteRegistration", {
              content_name: "Call for speakers",
            });
          }
          if (formId == 1) {
            fbq("track", "CompleteRegistration", {
              content_name: "Newsletter",
            });
          }
          if (formId == 7) {
            fbq("track", "CompleteRegistration", {
              content_name: "Volunteer",
            });
          }
          if (formId == 6) {
            fbq("track", "CompleteRegistration", {
              content_name: "Innovation Fair",
            });
          }
          if (formId == 5) {
            fbq("track", "CompleteRegistration", {
              content_name: "Trailblazers Fair",
            });
          }
          if (formId == 8) {
            fbq("track", "CompleteRegistration", {
              content_name: "Brochure",
            });
          } else {
            console.log("There is no event implementation for the form.");
          }
        }
      );
    });
    jQuery(".speakers-modal-open-btn").on("click", function (e) {
      e.preventDefault();
      jQuery("#registerModal").addClass("modal-open");
      jQuery("body").addClass("modal-open");
    });

    jQuery(".covid-modal-open-btn").on("click", function (e) {
      e.preventDefault();
      jQuery("#covidModal").addClass("modal-open");
      jQuery("body").addClass("modal-open");
    });

    jQuery(".code-conduct-modal-open-btn").on("click", function (e) {
      e.preventDefault();
      jQuery("#codeConductModal").addClass("modal-open");
      jQuery("body").addClass("modal-open");
    });

    jQuery(".terms-modal-open-btn").on("click", function (e) {
      e.preventDefault();
      jQuery("#termsModal").addClass("modal-open");
      jQuery("body").addClass("modal-open");
    });

    jQuery(".close").on("click", function () {
      jQuery(".register-form-modal").removeClass("modal-open");
      jQuery("body").removeClass("modal-open");
    });

    jQuery(document).keydown(function (event) {
      if (event.keyCode == 27) {
        jQuery(".register-form-modal").removeClass("modal-open");
        jQuery("body").removeClass("modal-open");
      }
    });

    jQuery(document).on("click", function (e) {
      if (
        !(
          jQuery(e.target).closest(
            ".speakers-modal-open-btn, .covid-modal-open-btn, .code-conduct-modal-open-btn, .terms-modal-open-btn"
          ).length > 0 || jQuery(e.target).closest(".modal-content").length > 0
        )
      ) {
        jQuery(".register-form-modal").removeClass("modal-open");
        jQuery("body").removeClass("modal-open");
      }
    });

    jQuery(".why-attend-timeline-link").on("click", function (e) {
      e.preventDefault();

      jQuery("html, body").animate(
        {
          scrollTop: jQuery(jQuery(this).attr("href")).offset().top - 50,
        },
        500,
        "linear"
      );
    });

    var urlFirstiFrame = jQuery("#stage-first").attr("src");
    var urlSecondiFrame = jQuery("#stage-second").attr("src");

    jQuery("#first-stage").on("click", function () {
      jQuery("#stage-second").attr("src", "");
      jQuery("#stage-first").attr("src", urlFirstiFrame);
    });

    jQuery("#second-stage").on("click", function () {
      jQuery("#stage-first").attr("src", "");
      jQuery("#stage-second").attr("src", urlSecondiFrame);
    });

    var body = document.getElementsByTagName("body")[0];
    var footerButtons = document.getElementsByClassName(
      "call-for-speaker-modal"
    );
    const openModalButtons = document.querySelectorAll(".open-modal-button");
    const modals = document.querySelectorAll(".modal");
    const closeButtons = document.querySelectorAll(".close-icon-button");

    function openModal(modal) {
      modal.style.display = "block";
      body.classList.add("body-overflow-fixed");
      modal.classList.add("filter-blur");

      document.addEventListener("keydown", handleEscapeKey);
    }

    var footerButtonsArray = Array.from(footerButtons);

    footerButtonsArray.forEach(function (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const selected = document.getElementById(
          "call-for-speakers-modal-footer"
        );
        openModal(selected);
      });
    });

    openModalButtons.forEach((button, index) => {
      button.addEventListener("click", (e) => {
        const modalId = button.getAttribute("data-modal-id");
        console.log(true);
        if (modalId) {
          e.preventDefault();
          const selectedModal = document.getElementById(modalId);
          if (selectedModal) {
            openModal(selectedModal);
          }
        } else {
          return;
        }
      });
    });

    function closeModal() {
      modals.forEach((modal) => {
        modal.style.display = "none";
        modal.classList.remove("filter-blur");
      });

      body.classList.remove("body-overflow-fixed");

      document.removeEventListener("keydown", handleEscapeKey);
    }

    closeButtons.forEach((closeButton, index) => {
      closeButton.addEventListener("click", closeModal);
    });

    window.addEventListener("click", function (event) {
      modals.forEach((modal) => {
        if (event.target === modal) {
          closeModal();
        }
      });
    });

    function handleEscapeKey(event) {
      if (event.key === "Escape") {
        closeModal();
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
